/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ListRelatedEntitiesInput = {
    /**
     * Root entity to traverse from.
     */
    entity_id: string;
    /**
     * Optional namespace id or name filter. Matching entities are returned with any intermediate path context.
     */
    target_namespace_id?: (string | null);
    /**
     * Which side of the entity relationship graph to traverse from the root entity.
     */
    direction?: ListRelatedEntitiesInput.direction;
    /**
     * Maximum traversal depth from the root entity.
     */
    depth?: number;
    /**
     * Maximum number of related entities to return, excluding the root entity.
     */
    limit?: number;
};

export namespace ListRelatedEntitiesInput {

    /**
     * Which side of the entity relationship graph to traverse from the root entity.
     */
    export enum direction {
        PARENTS = 'parents',
        CHILDREN = 'children',
        BOTH = 'both',
    }


}

